import React from 'react'
import { useTranslation } from 'react-i18next'
import { ToggleSwitch } from '@/ui/components/atoms/ToggleSwitch'

interface UserManagementTabsProps {
  activeTab: 'users' | 'responsibilities'
  onTabChange: (tab: 'users' | 'responsibilities') => void
}

export const UserManagementTabs: React.FC<UserManagementTabsProps> = ({ activeTab, onTabChange }) => {
  const { t } = useTranslation()

  const usersIcon = (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  )

  const responsibilitiesIcon = (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/>
      <rect x="9" y="3" width="6" height="4" rx="1"/>
      <path d="m9 12 2 2 4-4"/>
    </svg>
  )

  const options = [
    { value: 'users', label: t('admin.userManagement.tabs.users', 'Utilisateurs'), icon: usersIcon },
    { value: 'responsibilities', label: t('admin.userManagement.tabs.responsibilities', 'Responsabilités'), icon: responsibilitiesIcon }
  ] as [any, any] // Type assertion for tuple

  return (
    <ToggleSwitch
      options={options}
      value={activeTab}
      onChange={(value) => onTabChange(value as 'users' | 'responsibilities')}
      size="medium"
      colorScheme="default"
      aria-label="User management tab selector"
    />
  )
}
